const ZENDESK_BASE_URL = 'https://support.99designs.com';
const ZENDESK_LANGUAGES = ['en', 'de', 'es', 'fr', 'it', 'ja', 'nl', 'pt'];
const DEFAULT_LANGUAGE = 'en';

export function getSupportArticleUrl(zendeskId: string, lang: string) {
    return `${getSupportBaseUrl(lang)}/articles/${zendeskId}`;
}

export function getSupportCategoryUrl(zendeskId: string, lang: string) {
    return `${getSupportBaseUrl(lang)}/categories/${zendeskId}`;
}

export function getSupportSectionUrl(zendeskId: string, lang: string) {
    return `${getSupportBaseUrl(lang)}/sections/${zendeskId}`;
}

export function getSupportBaseUrl(lang = DEFAULT_LANGUAGE) {
    //Convert from RFC3066 to ISO639
    lang = lang.substring(0, 2);
    if (!ZENDESK_LANGUAGES.includes(lang)) {
        lang = DEFAULT_LANGUAGE;
    }
    return `${ZENDESK_BASE_URL}/hc/${lang}`;
}

export function getSupportContactUrl(lang: string) {
    return `${getSupportBaseUrl(lang)}/requests/new`;
}
